<template>
  <span
    v-if="icon"
    class="svg-icon"
    v-html="icon"
  />
</template>

<script setup lang="ts">
import type { Props } from './props'

const props = defineProps<Props>()

const icons = import.meta.glob('../../../assets/icons/*.svg', {
  as: 'raw',
  eager: true,
})
const icon = computed(() => icons[`../../../assets/icons/${props.name}.svg`])
</script>

<style scoped>
  .svg-icon :deep(svg) {
    display: inline-flex;
    fill: v-bind(props.fill);
    transition: fill 0.1s;
    width: v-bind(props.width);
    height: v-bind(props.height);
  }
</style>
